import { useFormik } from 'formik';
import React, { useState } from 'react';
import RecursiveContainer from './RecursiveContainer';
import { useTranslation } from 'react-i18next';

function ModuleFilters(props) {
    const {
        columnList,
        prefix,
        onFilter,
        validationSchema,
    } = props;

    const { t } = useTranslation();

    const initialValues = {};

    columnList.map((column) => {
        if (column.filter) {
            initialValues[column.dbname] = '';
        }
        return {};
    });

    const formik = useFormik({
        initialValues,
        onSubmit: values => {
            //setLoading(true);
            onFilter(values);
            //setLoading(false);
        },
        validationSchema
    });



    return (
        <div className={`card accordion-item m-1 filters-layout`}>
            <h2 className="accordion-header" id={`#${prefix}_filter_header`}>
                <button
                    type="button"
                    className={`accordion-button collapsed`}
                    data-bs-toggle="collapse"
                    data-bs-target={`#${prefix}_filters`}
                >
                    {t("Filters")}
                </button>
            </h2>
            <div
                id={`${prefix}_filters`}
                className="accordion-collapse collapse"
                aria-labelledby={`#${prefix}_filter_header`}
            >
                <div className="accordion-body">
                    <form onSubmit={formik.handleSubmit}>
                        <RecursiveContainer
                            config={columnList}
                            formik={formik}
                            prefix={prefix}
                            isFilter
                        />
                        <div className='row ' >
                            <div className='col-8'></div>
                            <div className='col-4 '>
                                <button type="reset" className="btn btn-outline-primary m-1" onClick={() => { formik.resetForm(); onFilter({}); }}>
                                    <span className="tf-icons bx bx-eraser"></span>&nbsp; {t("Clear Filters")}
                                </button>
                                <button type="submit" className="btn btn-primary m-a" >
                                    <span className="tf-icons bx bx-filter-alt"></span>&nbsp; {t("Filter")}
                                </button>
                            </div>


                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ModuleFilters;